<template>
  <div>
    <div class="d-flex mb-3 w-100">
      <h1 class="h4">{{ category[0].subscribedCategory }}</h1>
      <product-category-subscription
        :route="'/category/' + category[0].subscribedCategory + '/subscribe'"
        is-subscribed="true"
        :category-name="category[0].subscribedCategory"
      ></product-category-subscription>
    </div>
    <div class="row">
      <auction-card
        v-for="auction in category"
        v-bind:key="auction.id"
        v-bind:auction="auction"
      ></auction-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      required: true,
    },
  },
  data: function () {
    return { authenticated: window.authenticated };
  },
  methods: {
    getCsrfToken: function () {
      return document.querySelector('meta[name="csrf-token"]').content;
    },
  },
  watch: {
    "auction.current_round_price": function (newVal, oldVal) {
      const vm = this;
      if (!!vm.$refs.currentPrice) {
        vm.$refs.currentPrice.classList.add("flash");
        setTimeout(function () {
          if (!!vm.$refs.currentPrice) {
            vm.$refs.currentPrice.classList.remove("flash");
          }
        }, 2000);
      }
    },
  },
};
</script>
